export const CONSIGNMENT_LIST = 'CONSIGNMENT_LIST'